import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "wab",
  role: "alert"
}
const _hoisted_2 = { class: "wab-head" }
const _hoisted_3 = { class: "wab-title" }
const _hoisted_4 = { class: "wab-list" }
const _hoisted_5 = { class: "wab-name" }
const _hoisted_6 = {
  key: 0,
  class: "wab-where"
}
const _hoisted_7 = { class: "wab-min" }
const _hoisted_8 = {
  key: 0,
  class: "wab-more"
}

import { computed } from 'vue'
import { useRouter } from 'vue-router'
import { waitingAlert, alertTitle, dismissWaitingAlert } from '@/composables/useWaitingAlert'
import type { WaitingAlertNotification } from '@/composables/useConversationRealtime'

const MAX_SHOWN = 5

export default /*@__PURE__*/_defineComponent({
  __name: 'WaitingAlertBanner',
  setup(__props) {

const router = useRouter()

// Quem espera há mais tempo primeiro.
const sorted = computed(() => [...(waitingAlert.value?.conversations ?? [])].sort((a, b) => b.waitingMinutes - a.waitingMinutes))
const shown = computed(() => sorted.value.slice(0, MAX_SHOWN))
const hidden = computed(() => Math.max(0, (waitingAlert.value?.count ?? 0) - shown.value.length))

function where(c: WaitingAlertNotification['conversations'][number]) {
  return [c.teamName, c.flowName].filter(Boolean).join(' · ')
}

function goToQueue() {
  dismissWaitingAlert()
  router.push('/fila')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "wab" }, {
    default: _withCtx(() => [
      (_unref(waitingAlert))
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _cache[1] || (_cache[1] = _createElementVNode("svg", {
                class: "wab-icon",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "2",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              }, [
                _createElementVNode("path", { d: "M5 22h14" }),
                _createElementVNode("path", { d: "M5 2h14" }),
                _createElementVNode("path", { d: "M17 22v-4.17a2 2 0 0 0-.59-1.42L12 12l-4.41 4.41A2 2 0 0 0 7 17.83V22" }),
                _createElementVNode("path", { d: "M7 2v4.17a2 2 0 0 0 .59 1.42L12 12l4.41-4.41A2 2 0 0 0 17 6.17V2" })
              ], -1)),
              _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(alertTitle)(_unref(waitingAlert))), 1),
              _createElementVNode("button", {
                type: "button",
                class: "wab-close",
                "aria-label": "Fechar",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(dismissWaitingAlert) && _unref(dismissWaitingAlert)(...args)))
              }, "×")
            ]),
            _cache[2] || (_cache[2] = _createElementVNode("p", { class: "wab-sub" }, "Ninguém do time nem do fallback disponível pra receber.", -1)),
            _createElementVNode("ul", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(shown.value, (c) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: c.conversationId
                }, [
                  _createElementVNode("span", _hoisted_5, _toDisplayString(c.contactName), 1),
                  (where(c))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(where(c)), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", _hoisted_7, _toDisplayString(c.waitingMinutes) + " min", 1)
                ]))
              }), 128))
            ]),
            (hidden.value > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, "…e mais " + _toDisplayString(hidden.value), 1))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              type: "button",
              class: "wab-go",
              onClick: goToQueue
            }, "Ver fila")
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})